import React from "react";
import { Spin } from "antd";
import { Route, Routes } from "react-router-dom";
import {
  SignInPage,
  SignUpPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  LogoutPage,
  E404Page,
  DashboardPage,
  ZonesPage,
  SettingsPage,
  ZonesDetailsPage,
} from "components/Pages";

import AppError from "./AppError";
import AppMessage from "./AppMessage";
import PrivateRoute from "./PrivateRoute";

import { useSelector } from "react-redux";

const App = () => {
  const common = useSelector((state) => state.common);
  const globalLoading = common.globalLoading;

  return (
    <Spin spinning={globalLoading} wrapperClassName="wrap-spin">
      <AppError />
      <AppMessage />
      <Routes>
        <Route exact path="/login" element={<SignInPage />} />
        <Route exact path="/register" element={<SignUpPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/reset-password" element={<ResetPasswordPage />} />
        <Route exact path="/logout" element={<LogoutPage />} />
        <Route path="/" element={<PrivateRoute allowedRoles={['user', 'admin']} />} >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/zones" element={<ZonesPage />} />
          <Route path="/zones/:id" element={<ZonesDetailsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="/*" element={<E404Page />} />
      </Routes>
    </Spin>
  );
};
export default App;
